import { render, staticRenderFns } from "./VesselCurrentAIS.vue?vue&type=template&id=aacfcf0c&scoped=true&"
import script from "./VesselCurrentAIS.vue?vue&type=script&lang=js&"
export * from "./VesselCurrentAIS.vue?vue&type=script&lang=js&"
import style0 from "./VesselCurrentAIS.vue?vue&type=style&index=0&id=aacfcf0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacfcf0c",
  null
  
)

export default component.exports